

import React, {useRef} from 'react'
import './Header.css'
import { Container } from 'reactstrap'
import { NavLink, Link } from 'react-router-dom'

const NAV_LINKS = [
    {
        display: 'Home',
        url: './home'
    },

    {
        display: 'Market',
        url: './market'
    },

    {
        display: 'Create',
        url: './create'
    },

    {
        display: 'Contact',
        url: './contact'
    }

]

const Header = () => {




    // const headerRef = useRef(null)

    // useEffect(() => {
    //     window.addEventListener('scroll', () => {
    //         if(document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
    //             headerRef.current.classList.add('header_shrink')
    //         }
    //         else
    //         {
    //             headerRef.current.classList.remove('header_shrink')
    //         }
    //     })

    //     return () => {
    //         window.removeEventListener('scroll')
    //     }

    // },[])


    // ref={headerRef}
     // to be inside header className

     const menuRef = useRef()

  const menuToggle =() => menuRef.current.classList.toggle("active_menu")


  return (
   <header className='header' >
   <Container>
    <div className='navigate'>
    <div className='logo'>
        <h2 className='d-flex gap-2 align-tems-center'>
        <spam><i class="ri-fire-fill"></i>
        </spam> 
       ZAK NFTs
        </h2>
    </div>

    <div className='nav_menu' ref={menuRef} onClick={menuToggle}>
        <ul className='nav_list'>

        { NAV_LINKS.map((item, index ) =>  <li className='nav_item' kry={index}>
                <NavLink to={item.url} className={navClass => navClass.isActive? 'active'
                    : '' }>{item.display}</NavLink>
            </li>)
        }
           
        </ul>
    </div>

    <div className='nav_right d-flex align-items-center  gap-5'>
        <button className='btn d-flex gap-2 align-items-center'> 
        <span> <i class="ri-wallet-line"></i></span>
       
        <Link to='/wallet'> 
        Connect to wallet</Link></button>
        <span className='mobile_menu'> <i class="ri-menu-line"  onClick={menuToggle}></i></span>
       
    </div>

    </div>
   </Container>

   </header>
  )
}

export default Header